/* eslint-disable react/prop-types */
/**
 * Phase 19 — per-battery effectiveness card (WS-E result panel,
 * shipped in CP4 for the preview).
 *
 * Plain Tailwind card; no chart library. Tabular numerals for the
 * pk_observed / engagements_fired columns so procurement-evaluator
 * readers can scan rows by eye. Defence palette throughout.
 */
import { DEFENCE_PALETTE } from "@/components/phase19/placementUtils";

export default function PerBatteryEffectivenessCard({ perBattery = {} }) {
    const rows = Object.entries(perBattery)
        .map(([battery_id, stats]) => ({
            battery_id,
            engagements_fired: stats?.engagements_fired ?? 0,
            successes: stats?.successes ?? 0,
            pk_observed: stats?.pk_observed ?? 0,
        }))
        .sort((a, b) => a.battery_id.localeCompare(b.battery_id));
    return (
        <section
            className="rounded-md border p-3"
            style={{ borderColor: DEFENCE_PALETTE.steelGray }}
            data-testid="per-battery-effectiveness-card"
        >
            <header
                className="mb-2 text-[11px] uppercase tracking-wide"
                style={{ color: DEFENCE_PALETTE.navy }}
            >
                Per-battery effectiveness
            </header>
            {rows.length === 0 ? (
                <p
                    className="text-[11px]"
                    style={{ color: DEFENCE_PALETTE.steelGray }}
                >
                    No engagements logged yet.
                </p>
            ) : (
                <table className="w-full text-xs">
                    <thead>
                        <tr style={{ color: DEFENCE_PALETTE.steelGray }}>
                            <th className="text-left font-medium">Battery</th>
                            <th className="text-right font-medium">Fired</th>
                            <th className="text-right font-medium">Hits</th>
                            <th
                                className="text-right font-medium"
                                title="Observed engagement Pk — hits / fired"
                            >
                                Pk̂
                            </th>
                        </tr>
                    </thead>
                    <tbody style={{ fontVariantNumeric: "tabular-nums" }}>
                        {rows.map((r) => (
                            <tr
                                key={r.battery_id}
                                className="border-t"
                                style={{ borderColor: "#E5EAF0" }}
                                data-testid={`bat-row-${r.battery_id}`}
                            >
                                <td
                                    className="py-1"
                                    style={{ color: DEFENCE_PALETTE.navy }}
                                >
                                    {r.battery_id}
                                </td>
                                <td className="py-1 text-right">
                                    {r.engagements_fired}
                                </td>
                                <td className="py-1 text-right">
                                    {r.successes}
                                </td>
                                <td
                                    className="py-1 text-right"
                                    style={{ color: DEFENCE_PALETTE.teal }}
                                >
                                    {(r.pk_observed * 100).toFixed(1)}%
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </section>
    );
}
